import axios from '../axios';
import { OPEN_AI_PRODUCT_DESCRIPTION, OPEN_AI_PRODUCT_NAME } from '../ApiUrl';

export const openAiProductNameAPI = async (payload = {}) => {
  try {
    return await axios.post(OPEN_AI_PRODUCT_NAME, payload);
  } catch (error) {
    console.log('openAiProductNameAPI catch', error);
    return { hasError: true, message: error?.message || 'Request failed', data: { success: false } };
  }
};

export const openAiProductDescriptionAPI = async (payload = {}) => {
  try {
    return await axios.post(OPEN_AI_PRODUCT_DESCRIPTION, payload);
  } catch (error) {
    console.log('openAiProductDescriptionAPI catch', error);
    return { hasError: true, message: error?.message || 'Request failed', data: { success: false } };
  }
};
